import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { reducers } from './store/reducers';
import { CustomSerializer } from './store/router/custom-route-serializer';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from 'src/environments/environment';
import { SharedModule } from './shared/shared.module';
import { PagesModule } from './pages/pages.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './material/material.module';
import { AdminLayoutComponent } from './layout/admin-layout/admin-layout.component';
import { PageContentComponent } from './layout/page-content/page-content.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ErrorInterceptor, TokenInterceptor } from './interceptor/token.interceptor';
import { effects } from './store/effects';
import { BsModalService } from 'ngx-bootstrap/modal';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { AuthLayoutComponent } from './layout/auth-layout/auth-layout.component';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { MatDatetimepickerModule } from '@mat-datetimepicker/core';
import { MatNativeDatetimeModule } from '@mat-datetimepicker/core';
import { NgChartsModule } from 'ng2-charts';
import { UppercaseDirective } from './directives/uppercase.directive';
import { metaReducers } from './store/reducers/app.reducer';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { WatermarkComponent } from './shared/component/watermark/watermark.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { DownloadDirective } from './directives/download.directive';
import { ZXingScannerModule } from '@zxing/ngx-scanner';

@NgModule({
  declarations: [
    AppComponent,
    AdminLayoutComponent,
    PageContentComponent,
    AuthLayoutComponent,
    UppercaseDirective,
    WatermarkComponent    
  ],
  imports: [
    ReactiveFormsModule,
    NgbModule,
    SharedModule,
    PagesModule,
    BrowserModule,
    AppRoutingModule,
    ImageCropperModule,
    StoreModule.forRoot(reducers, {
      metaReducers,
      runtimeChecks: {
        strictStateImmutability: false,
        strictActionImmutability: false,
      },
    }),
    EffectsModule.forRoot(effects),
    StoreRouterConnectingModule.forRoot({
      serializer: CustomSerializer
    }),
    EffectsModule.forRoot(effects),
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production }),
    BrowserAnimationsModule,
    MaterialModule,
    HttpClientModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    DragDropModule,
    NgxDaterangepickerMd.forRoot(),
    MatNativeDatetimeModule,
    MatDatetimepickerModule,
    NgChartsModule,
    ZXingScannerModule
  ],
  providers: [
    BsModalService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false }
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
